export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";